<script>
    export default {
        props: ['data'],
        data () {
            return {
            }
        }
    };
</script>
<template>
    <div class="about-section section-space--inner--80">
        <div class="container">
            <div class="row row-25 align-items-center">
                <div class="col-lg-6 col-12 mb-30">
                    <div class="about-image-two">
                        <img :src="data.image" class="rounded" alt="image">
                    </div>
                </div>
                <div class="col-lg-6 col-12 mb-30">
                    <div class="about-content-two">
                        <h3 class="text-color-green">SEJARAH</h3>
                        <h1>{{ data.title }}</h1>
                        <div v-html="data.body"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
